import React from "react"

import moment from "moment"
import DatePicker from "react-datepicker"

import ImageSelector from "../../../common/ImageSelector"
import { languageCodeMapping } from "../../../../config/language-definitions"
import { sourceLanguages } from "../../../../config/application-definitions"

const EditFeedItemPublishingDetails = ({
    publisher,
    link,
    title,
    time,
    timeAnalyzed,
    imagePreviewURL,
    image,
    language,
    onValueChange,
    onEventChange,
    onImageChange,
    onImageRemove
}) => (
    <div className="widget">
        <div className="widget-content">
            <h3 className="first-heading">
                <span className="icon icon-source" />Publisher
            </h3>
            <input
                name="publisher"
                type="text"
                className="form-control"
                placeholder="Publisher"
                value={publisher}
                onChange={onEventChange}
            />
            <p className="source-info">
                <a href={link} target="_blank" rel="noopener noreferrer">
                    {link}
                </a>
            </p>
            <h3>
                <span className="icon icon-headline" />Headline
            </h3>
            <input
                name="title"
                type="text"
                className="form-control"
                placeholder="Title"
                value={title}
                onChange={onEventChange}
            />
            <h3>
                <span className="icon icon-headline" />Publishing time
            </h3>
            <div className="form-group">
                <DatePicker
                    name="time"
                    placeholder="Publishing time"
                    className="form-control"
                    selected={time}
                    onChange={onValueChange("time")}
                    showTimeSelect={true}
                    timeIntervals={1}
                    timeFormat="HH:mm"
                    dateFormat="LLL"
                    maxDate={moment()}
                    locale={moment.locale()}
                />
            </div>
            <h3>
                <span className="icon icon-headline" />Added on
            </h3>
            <div className="form-group">
                <DatePicker
                    name="time_analyzed"
                    placeholder="Publishing time"
                    className="form-control"
                    selected={timeAnalyzed}
                    onChange={onValueChange("time_analyzed")}
                    showTimeSelect={true}
                    timeIntervals={1}
                    timeFormat="HH:mm"
                    dateFormat="LLL"
                    maxDate={moment()}
                    locale={moment.locale()}
                    disabled={true}
                />
            </div>
            <h3 style={{ clear: "both" }}>
                <span className="icon icon-lang" />Language
            </h3>
            <select
                className="form-control"
                name="language"
                value={language}
                onChange={onEventChange}
            >
                {(language !== "" &&
                !sourceLanguages.some(({ id }) => id === language)
                    ? sourceLanguages.concat([
                          {
                              label: (languageCodeMapping[language] || {}).name,
                              id: language
                          }
                      ])
                    : sourceLanguages
                ).map(({ label, id }) => (
                    <option key={id} value={id}>
                        {label}
                    </option>
                ))}
            </select>
            <h3>
                <span className="icon icon-heroimg" />Hero image
            </h3>
            <ImageSelector
                imageUrl={
                    imagePreviewURL !== undefined ? imagePreviewURL : image
                }
                onImageSelect={onImageChange}
            />
        </div>
    </div>
)

export default EditFeedItemPublishingDetails
